import { render, staticRenderFns } from "./RecipeNutritionInfoItem.vue?vue&type=template&id=5d7d212b&scoped=true&"
import script from "./RecipeNutritionInfoItem.vue?vue&type=script&lang=js&"
export * from "./RecipeNutritionInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./RecipeNutritionInfoItem.vue?vue&type=style&index=0&id=5d7d212b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d212b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7d212b')) {
      api.createRecord('5d7d212b', component.options)
    } else {
      api.reload('5d7d212b', component.options)
    }
    module.hot.accept("./RecipeNutritionInfoItem.vue?vue&type=template&id=5d7d212b&scoped=true&", function () {
      api.rerender('5d7d212b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeNutritionInfoItem.vue"
export default component.exports